<script setup>

    const props = defineProps({
        progress: {
            default: '0'
        },
        label: {
            type: String,
            default: ' Complete'
        }
    })

</script>

<template>

    <div class="flex gap-x-4">

        <div class="w-36 bg-lifeworx-blue-700 border-lifeworx-blue-700 ring-offset-1 p-0.5 border-opacity-50 rounded-md h-3 ring-lifeworx-blue-700 ring-1 ring-offset-lifeworx-blue-100 self-center">
            <div class="w-full rounded h-full overflow-clip">
                <div class="bg-white h-3" :style="'width: ' + progress + '%;'"></div>
            </div>
            <div class="relative -top-2.5">
                <div class="grid grid-cols-4 h-3 divide-x divide-lifeworx-blue-600 divide-opacity-100">
                    <div class="h-full"></div>
                    <div class="h-full"></div>
                    <div class="h-full"></div>
                    <div class="h-full"></div>
                </div>
            </div>
        </div>

        <div class="flex-shrink-0">
            <h2 class="text-white text-xs font-semibold drop-shadow tracking-wide select-none cursor-default">
                {{ progress }}%{{ label }}
            </h2>
        </div>


    </div>

</template>
